const itemId = function (item) {
    if (item.hasOwnProperty('uuid')) {
        return item.uuid;
    }
    if (item.hasOwnProperty('id')) {
        return item.id;
    }
    if (item.hasOwnProperty('tempGeneratedId')) {
        return item.tempGeneratedId;
    }
    item.tempGeneratedId = generateRandomString(20);
    return item.tempGeneratedId;
};

const VueHelpers = {
    install(Vue, options) {
        Vue.mixin({
            methods: {
                itemId(item) {
                    if (item.hasOwnProperty('uuid')) {
                        return item.uuid;
                    }
                    if (item.hasOwnProperty('id')) {
                        return item.id;
                    }
                    if (item.hasOwnProperty('tempGeneratedId')) {
                        return item.tempGeneratedId;
                    }
                    item.tempGeneratedId = generateRandomString(20);
                    return item.tempGeneratedId;
                },

                generateRandomString(length, chars) {
                    if (typeof length === 'undefined') {
                        length = 7;
                    }
                    if (typeof chars === 'undefined') {
                        chars = '#aA';
                    }

                    let mask = '';
                    if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
                    if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                    if (chars.indexOf('#') > -1) mask += '0123456789';
                    if (chars.indexOf('!') > -1) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';
                    let result = '';
                    for (let i = length; i > 0; --i) result += mask[Math.round(Math.random() * (mask.length - 1))];
                    return result;
                },

                convertRemToPixels(rem) {
                    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
                },

                convertValueToPixels(value){
                    if (typeof value === "number"){
                        return value;
                    }
                    if (typeof value !== "string"){
                        return parseInt(value);
                    }
                    value = value.toLowerCase();
                    if (value.indexOf('px') > -1){
                        return parseInt(value.replace('px',''));
                    }
                    if (value.indexOf('rem') > -1){
                        return this.convertRemToPixels(parseInt(value.replace('rem','')));
                    }
                    if (value.indexOf('em') > -1){
                        return this.convertRemToPixels(parseInt(value.replace('em','')));
                    }
                    return parseInt(value);
                }
            },
        });
    },
};

export default VueHelpers;
